export const MANAGEMENT_DASHBOARD_SYSTEM_NAME = "Executive Dashboard";